import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Bootstrap
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Common
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';

// Translation
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import localeIt from '@angular/common/locales/it';
registerLocaleData(localeIt);
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?cb=' + new Date().getTime());
}

// Modules
import { AuthModule } from './auth/auth.module';
import { AgentBuilderModule } from './agent-builder/agent-builder.module';
import { OrganizationBuilderModule } from './organization-builder/organization-builder.module';
import { UnitDetailsModule } from './unit-details/unit-details.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    MatDialogModule,
    AuthModule,
    AgentBuilderModule,
    OrganizationBuilderModule,
    UnitDetailsModule,
  ],
  providers: [DatePipe, DecimalPipe, { provide: LOCALE_ID, useValue: 'it-IT' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
